
(function() {
  var result = { translations: { "de": { "SharedI18nStrings": { "languageNames": { "af": "Afrikaans", "sq": "Albanisch", "sq-al": "Albanisch \u2013 Albanien", "ar": "Arabisch", "ar-dz": "Arabisch \u2013 Algerien", "ar-bh": "Arabisch \u2013 Bahrain", "ar-eg": "Arabisch \u2013 \xC4gypten", "ar-iq": "Arabisch \u2013 Irak", "ar-jo": "Arabisch \u2013 Jordanien", "ar-kw": "Arabisch \u2013 Kuwait", "ar-lb": "Arabisch \u2013 Libanon", "ar-ly": "Arabisch \u2013 Libyen", "ar-ma": "Arabisch \u2013 Marokko", "ar-om": "Arabisch \u2013 Oman", "ar-qa": "Arabisch \u2013 Katar", "ar-sa": "Arabisch \u2013 Saudi-Arabien", "ar-sd": "Arabisch \u2013 Sudan", "ar-sy": "Arabisch \u2013 Syrien", "ar-tn": "Arabisch \u2013 Tunesien", "ar-ae": "Arabisch \u2013 Vereinigte Arabische Emirate", "ar-ye": "Arabisch \u2013 Jemen", "as": "Assamesisch", "az": "Aserbaidschanisch", "hy": "Armenisch", "eu": "Baskisch", "be": "Wei\xDFrussisch", "be-by": "Wei\xDFrussisch \u2013 Wei\xDFrussland", "bn": "Bengali", "bg": "Bulgarisch", "bg-bg": "Bulgarisch \u2013 Bulgarien", "bs": "Bosnisch", "ca": "Katalanisch", "ca-es": "Katalanisch \u2013 Katalonien", "zh": "Chinesisch", "zh-cn": "Chinesisch \u2013 vereinfacht", "zh-hk": "Chinesisch \u2013 Hong Kong", "zh-mo": "Chinesisch \u2013 Macau", "zh-sg": "Chinesisch \u2013 Singapur", "zh-tw": "Chinesisch \u2013 traditionell", "zh-chs": "Chinesisch (vereinfacht)", "zh-cht": "Chinesisch (traditionell)", "zh-hans": "Chinesisch (vereinfachte Han-Schriftzeichen)", "zh-hant": "Chinesisch (traditionelle Han-Schriftzeichen)", "hr": "Kroatisch", "hr-hr": "Kroatisch \u2013 Kroatien", "cs": "Tschechisch", "cs-cz": "Tschechisch \u2013 Tschechische Republik", "da": "D\xE4nisch", "da-dk": "D\xE4nisch \u2013 D\xE4nemark", "nl": "Niederl\xE4ndisch", "nl-be": "Niederl\xE4ndisch \u2013 Belgien", "nl-ch": "Niederl\xE4ndisch - Schweiz", "nl-lu": "Niederl\xE4ndisch \u2013 Luxemburg", "nl-nl": "Niederl\xE4ndisch \u2013 Niederlande", "en": "Englisch", "en-ae": "Englisch \u2013 Vereinigte Arabische Emirate", "en-au": "Englisch \u2013 Australien", "en-be": "Englisch \u2013 Belgien", "en-ca": "Englisch \u2013 Kanada", "en-ch": "Englisch - Schweiz", "en-cn": "Englisch \u2013 China", "en-de": "Englisch - Deutschland", "en-ee": "Englisch - Estland", "en-es": "Englisch - Spanien", "en-fr": "Englisch - Frankreich", "en-hk": "Englisch \u2013 Hongkong", "en-in": "Englisch \u2013 Indien", "en-ie": "Englisch \u2013 Irland", "en-ke": "Englisch \u2013 Kenia", "en-lu": "Englisch \u2013 Luxemburg", "en-my": "Englisch \u2013 Malaysia", "en-mt": "Englisch \u2013 Malta", "en-mx": "Englisch - Mexiko", "en-nl": "Englisch \u2013 Niederlande", "en-nz": "Englisch \u2013 Neuseeland", "en-ph": "Englisch \u2013 Philippinen", "en-pk": "Englisch \u2013 Pakistan", "en-se": "Englisch - Schweden", "en-sg": "Englisch \u2013 Singapur", "en-tn": "Englisch - Tunesien", "en-za": "Englisch \u2013 S\xFCdafrika", "en-gb": "Englisch \u2013 Vereinigtes K\xF6nigreich", "en-us": "Englisch \u2013 USA", "en-zw": "Englisch \u2013 Simbabwe", "et": "Estnisch", "et-ee": "Estnisch \u2013 Estland", "fo": "F\xE4r\xF6isch", "fa": "Farsi", "fi": "Finnisch", "fi-fi": "Finnisch \u2013 Finnland", "fil": "Philippinisch", "fr": "Franz\xF6sisch", "fr-be": "Franz\xF6sisch \u2013 Belgien", "fr-ca": "Franz\xF6sisch \u2013 Kanada", "fr-fr": "Franz\xF6sisch \u2013 Frankreich", "fr-lu": "Franz\xF6sisch \u2013 Luxemburg", "fr-mc": "Franz\xF6sisch \u2013 Marokko", "fr-ch": "Franz\xF6sisch \u2013 Schweiz", "fr-tn": "Franz\xF6sisch - Tunesien", "gl": "Galizisch", "ka": "Georgisch", "de": "Deutsch", "de-at": "Deutsch \u2013 \xD6sterreich", "de-de": "Deutsch \u2013 Deutschland", "de-gr": "Deutsch \u2013 Griechenland", "de-li": "Deutsch \u2013 Liechtenstein", "de-lu": "Deutsch \u2013 Luxemburg", "de-ch": "Deutsch \u2013 Schweiz", "el": "Griechisch", "el-cy": "Griechisch \u2013 Zypern", "el-gr": "Griechisch \u2013 Griechenland", "gu": "Gujarati", "haw": "Hawaiisch", "ha": "Hausa", "he": "Hebr\xE4isch", "he-il": "Hebr\xE4isch \u2013 Israel", "iw-il": "Hebr\xE4isch \u2013 Israel", "hi": "Hindi", "hi-in": "Hindi \u2013 Indien", "hu": "Ungarisch", "hu-hu": "Ungarisch \u2013 Ungarn", "is": "Isl\xE4ndisch", "is-is": "Isl\xE4ndisch \u2013 Island", "id": "Indonesisch", "in-id": "Indonesisch \u2013 Indonesien", "ga": "Irisch", "ga-ie": "Irisch \u2013 Irland", "it": "Italienisch", "it-it": "Italienisch \u2013 Italien", "it-ch": "Italienisch \u2013 Schweiz", "ja": "Japanisch", "ja-jp": "Japanisch - Japan", "kn": "Kanada", "kk": "Kasachisch", "kok": "Konkani", "ko": "Koreanisch", "ko-kr": "Koreanisch \u2013 S\xFCdkorea", "ku": "Kurdisch", "ky": "Kirgisisch", "ky-kg": "Kirgisisch", "lo": "Lao", "lv": "Lettisch", "lv-lv": "Lettisch \u2013 Lettland", "lt": "Litauisch", "lt-lt": "Litauisch \u2013 Litauen", "mk": "Mazedonisch", "mk-mk": "Mazedonisch \u2013 Mazedonien", "ml": "Malayalam", "ms": "Malaiisch", "ms-bn": "Malaiisch \u2013 Brunei", "ms-my": "Malaiisch \u2013 Malaysia", "mt": "Maltesisch", "mt-mt": "Maltesisch \u2013 Malta", "mr": "Marathi", "mn": "Mongolisch", "my": "Birmanisch", "my-mm": "Birmanisch \u2013 Myanmar (Birma)", "ne": "Nepali", "no": "Norwegisch", "nb": "Norwegisches Bokmal", "nb-no": "Norwegisches Bokmal - Norwegen", "no-no": "Norwegisch \u2013 Norwegen", "pl": "Polnisch", "pl-pl": "Polnisch \u2013 Polen", "pt": "Portugiesisch", "pt-br": "Portugiesisch \u2013 Brasilien", "pt-pt": "Portugiesisch \u2013 Portugal", "pa": "Panjabi", "pa-in": "Punjabi \u2013 Indien", "pa-pk": "Punjabi \u2013 Pakistan", "ro": "Rum\xE4nisch", "ro-ro": "Rum\xE4nisch \u2013 Rum\xE4nien", "ru": "Russisch", "ru-ru": "Russisch \u2013 Russland", "rw-rw": "Kinyarwanda", "sa": "Sanskrit", "si": "Singhalesisch", "sr": "Serbisch", "sr-ba": "Serbisch \u2013 Bosnien und Herzegowina", "sr-me": "Serbisch \u2013 Montenegro", "sr-rs": "Serbisch \u2013 Serbien", "sr-cs": "Serbisch \u2013 Serbien und Montenegro (ehemals)", "sk": "Slowakisch", "sk-sk": "Slowakisch \u2013 Slowakei", "sl": "Slowenisch", "sl-si": "Slowenisch \u2013 Slowenien", "es": "Spanisch", "es-ar": "Spanisch \u2013 Argentinien", "es-bo": "Spanisch \u2013 Bolivien", "es-cl": "Spanisch \u2013 Chile", "es-co": "Spanisch \u2013 Kolumbien", "es-cr": "Spanisch \u2013 Costa Rica", "es-cu": "Spanisch \u2013 Kuba", "es-do": "Spanisch \u2013 Dominikanische Republik", "es-ec": "Spanisch \u2013 Ecuador", "es-sv": "Spanisch \u2013 El Salvador", "es-gt": "Spanisch \u2013 Guatemala", "es-hn": "Spanisch \u2013 Honduras", "es-mx": "Spanisch \u2013 Mexiko", "es-ni": "Spanisch \u2013 Nicaragua", "es-pa": "Spanisch \u2013 Panama", "es-py": "Spanisch \u2013 Paraguay", "es-pe": "Spanisch \u2013 Peru", "es-pr": "Spanisch \u2013 Puerto Rico", "es-es": "Spanisch \u2013 Spanien", "es-us": "Spanisch \u2013 Vereinigte Staaten", "es-uy": "Spanisch \u2013 Uruguay", "es-ve": "Spanisch \u2013 Venezuela", "sw": "Swahili", "sv": "Schwedisch", "sv-fi": "Schwedisch \u2013 Finnland", "sv-se": "Schwedisch \u2013 Schweden", "sy": "Syrisch", "ta": "Tamil", "tt": "Tatarisch", "te": "Telugu", "th": "Thail\xE4ndisch", "th-th": "Thail\xE4ndisch \u2013 Thailand", "tl": "Tagalog", "tr": "T\xFCrkisch", "tr-tr": "T\xFCrkisch \u2013 T\xFCrkei", "uk": "Ukrainisch", "uk-ua": "Ukrainisch \u2013 Ukraine", "ur": "Urdu", "uz": "Usbekisch", "vi": "Vietnamesisch", "vi-vn": "Vietnamesisch \u2013 Vietnam", "yi": "Jiddisch", "zu": "Zulu" } } } } };
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "SharedI18nStrings": {
    "af": "static-1.161",
    "ar-eg": "static-1.161",
    "ar-sa": "static-1.161",
    "ar": "static-1.161",
    "be": "static-1.161",
    "bg": "static-1.161",
    "bn": "static-1.161",
    "ca-es": "static-1.161",
    "ca": "static-1.161",
    "cs": "static-1.161",
    "da": "static-1.161",
    "de": "static-1.161",
    "el": "static-1.161",
    "en-gb": "static-1.161",
    "en": "static-1.161",
    "es-ar": "static-1.161",
    "es-es": "static-1.161",
    "es-mx": "static-1.161",
    "es": "static-1.161",
    "et": "static-1.161",
    "eu": "static-1.161",
    "fi": "static-1.161",
    "fr-ca": "static-1.161",
    "fr": "static-1.161",
    "gl": "static-1.161",
    "gu": "static-1.161",
    "he-il": "static-1.161",
    "he": "static-1.161",
    "hi": "static-1.161",
    "hr": "static-1.161",
    "hu": "static-1.161",
    "hy": "static-1.161",
    "id": "static-1.161",
    "is": "static-1.161",
    "it": "static-1.161",
    "ja": "static-1.161",
    "ka": "static-1.161",
    "kk": "static-1.161",
    "kn": "static-1.161",
    "ko": "static-1.161",
    "ky": "static-1.161",
    "lt": "static-1.161",
    "lv": "static-1.161",
    "mk": "static-1.161",
    "mn": "static-1.161",
    "mr": "static-1.161",
    "ms-my": "static-1.161",
    "ms": "static-1.161",
    "nl-be": "static-1.161",
    "nl-nl": "static-1.161",
    "nl": "static-1.161",
    "no": "static-1.161",
    "pl": "static-1.161",
    "pt-br": "static-1.161",
    "pt-pt": "static-1.161",
    "ro": "static-1.161",
    "ru": "static-1.161",
    "sk": "static-1.161",
    "sl": "static-1.161",
    "sq": "static-1.161",
    "sr": "static-1.161",
    "sv": "static-1.161",
    "sw": "static-1.161",
    "ta": "static-1.161",
    "te": "static-1.161",
    "th": "static-1.161",
    "tl": "static-1.161",
    "tr": "static-1.161",
    "uk": "static-1.161",
    "ur": "static-1.161",
    "vi": "static-1.161",
    "zh-cn": "static-1.161",
    "zh-hans": "static-1.161",
    "zh-hant": "static-1.161",
    "zh-hk": "static-1.161",
    "zh-tw": "static-1.161"
  }
};
  hns('I18n', result);

})();



(function() {
  var result = { translations: { "de": { "i18n": { "duration": { "seconds": "{{ seconds }} Sek.", "minutes": "{{ minutes }} Min.", "hours": "{{ hours }} Std.", "hoursAndMinutes": "{{ hours }} Std. {{ minutes }} Min.", "days": "{{ days }} Tage", "shortForm": { "seconds": "{{ seconds }} Sek.", "minutes": "{{ minutes }} Min.", "hours": "{{ hours }} Std.", "days": "{{ days }} Tage", "hoursAndMinutes": "{{ hours }} Std. {{ minutes }} Min." } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, Durchwahl {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "de": "static-7.1359"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1359",
    "ar-eg": "static-7.1359",
    "bg": "static-7.1359",
    "bn": "static-7.1359",
    "ca-es": "static-7.1359",
    "cs": "static-7.1359",
    "da": "static-7.1359",
    "de": "static-7.1359",
    "el": "static-7.1359",
    "en-gb": "static-7.1359",
    "en": "static-7.1359",
    "es-mx": "static-7.1359",
    "es": "static-7.1359",
    "et": "static-7.1359",
    "fi": "static-7.1359",
    "fr-ca": "static-7.1359",
    "fr": "static-7.1359",
    "he-il": "static-7.1359",
    "hi": "static-7.1359",
    "hr": "static-7.1359",
    "hu": "static-7.1359",
    "id": "static-7.1359",
    "it": "static-7.1359",
    "ja": "static-7.1359",
    "ko": "static-7.1359",
    "lt": "static-7.1359",
    "ms": "static-7.1359",
    "nl": "static-7.1359",
    "no": "static-7.1359",
    "pl": "static-7.1359",
    "pt-br": "static-7.1359",
    "pt-pt": "static-7.1359",
    "ro": "static-7.1359",
    "ru": "static-7.1359",
    "sk": "static-7.1359",
    "sl": "static-7.1359",
    "sv": "static-7.1359",
    "th": "static-7.1359",
    "tl": "static-7.1359",
    "tr": "static-7.1359",
    "uk": "static-7.1359",
    "vi": "static-7.1359",
    "x-pseudo": "static-7.1359",
    "zh-cn": "static-7.1359",
    "zh-hk": "static-7.1359",
    "zh-tw": "static-7.1359"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:de', {version: 'static-7.1359'}); }
})();



(function() {
  var result = { translations: { "de": { "videoPlayer": { "htmlTitle": "HubSpot Video", "htmlTitleWithVideo": "{{ videoTitle }} | HubSpot Video", "controls": { "audioPlayer": "Audio-Player", "videoPlayer": "Video-Player", "play": "Abspielen", "playVideo": "Video abspielen", "pause": "Pausieren", "replay": "Erneut wiedergeben", "currentTime": "Aktuelle Uhrzeit", "duration": "Dauer", "remainingTime": "Verbleibende Zeit", "fullscreen": "Vollbild", "exitFullscreen": "Vollbild beenden", "mute": "Stummschalten", "unmute": "Stummschalten aufheben", "volumeLevel": "Lautst\xE4rke", "captions": "Untertitel", "captionsOff": "Aus", "seekBar": "Position anpassen", "chapter": "Kapitel", "elapsedTime": "Verstrichene Zeit: {{timeDisplay}}" }, "playbackOptions": { "buttonTitle": "Wiedergabeoptionen", "playbackRate": "Wiedergabegeschwindigkeit:", "quality": "Qualit\xE4t:", "normal": "Normal", "auto": "(Auto)" }, "formModal": { "defaultThankYouMessage": "Vielen Dank f\xFCr Ihre Antwort!", "inlineMessageButton": "Video abspielen" }, "ctaModal": { "imgAlt": "Video-CTA" }, "errors": { "generic": { "heading": "Video konnte nicht geladen werden" }, "UNAUTHORIZED": { "heading": "Video nicht aktiviert" }, "VIDEO_NOT_FOUND": { "heading": "Video nicht gefunden" }, "INVALID_URL": { "heading": "Video nicht gefunden" }, "UNSUPPORTED_EMBED": { "heading": "Video nicht verf\xFCgbar", "extra": "Dieses Video kann extern nicht angezeigt werden." }, "refreshLink": "Erneut versuchen" } } } } };
  result.translationsLoaded = {
  "video-player-ui": {
    "de": "static-1.29208"
  }
};
  result.translationsAvailable = {
  "video-player-ui": {
    "af": "static-1.29208",
    "ar-eg": "static-1.29208",
    "bg": "static-1.29208",
    "bn": "static-1.29208",
    "ca-es": "static-1.29208",
    "cs": "static-1.29208",
    "da": "static-1.29208",
    "de": "static-1.29208",
    "el": "static-1.29208",
    "en-gb": "static-1.29208",
    "en": "static-1.29208",
    "es-mx": "static-1.29208",
    "es": "static-1.29208",
    "et": "static-1.29208",
    "fi": "static-1.29208",
    "fr-ca": "static-1.29208",
    "fr": "static-1.29208",
    "he-il": "static-1.29208",
    "hi": "static-1.29208",
    "hr": "static-1.29208",
    "hu": "static-1.29208",
    "id": "static-1.29208",
    "it": "static-1.29208",
    "ja": "static-1.29208",
    "ko": "static-1.29208",
    "lt": "static-1.29208",
    "ms": "static-1.29208",
    "nl": "static-1.29208",
    "no": "static-1.29208",
    "pl": "static-1.29208",
    "pt-br": "static-1.29208",
    "pt-pt": "static-1.29208",
    "ro": "static-1.29208",
    "ru": "static-1.29208",
    "sk": "static-1.29208",
    "sl": "static-1.29208",
    "sv": "static-1.29208",
    "th": "static-1.29208",
    "tl": "static-1.29208",
    "tr": "static-1.29208",
    "uk": "static-1.29208",
    "vi": "static-1.29208",
    "zh-cn": "static-1.29208",
    "zh-hk": "static-1.29208",
    "zh-tw": "static-1.29208"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:video-player-ui:de', {version: 'static-1.29208'}); }
})();


